import { BUCKETS } from './BUCKETS';

/** Banner desktop genérico (catálogo premiums y categorías sin imagen propia). */
export const CATEGORY_DEFAULT_BANNER_DESKTOP_URL = `https://${BUCKETS.bucketAssets}.s3.us-east-1.amazonaws.com/categories/banners/banner_web.avif`;

/** Banner mobile genérico (catálogo premiums y categorías sin imagen propia). */
export const CATEGORY_DEFAULT_BANNER_MOBILE_URL = `https://${BUCKETS.bucketAssets}.s3.us-east-1.amazonaws.com/categories/banners/banner_mobile.avif`;
